import { ServerAPI } from '../GeneralFunction';

const AggregatedReportsAPI = {
	getdomainlist: (data) => {
		let url = "get_aggregated_domain_list";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
	getvisioptcampaignlist: (data) => {
		let url = "get_aggregated_visiopt_campaign_list";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
	gettrafficsourcelist: (data) => {
		let url = "get_aggregated_traffic_source_list";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
	getsourceitemlist: (data) => {
		let url = "get_aggregated_source_item_list";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
	getadcampaignlist: (data) => {
		let url = "get_aggregated_ad_campaign_list";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
	getadsetlist: (data) => {
		let url = "get_aggregated_ad_set_list";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
	getadlist: (data) => {
		let url = "get_aggregated_ad_list";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
	getreportlist: (data) => {
		let url = "get_aggregated_report_list";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
	deletereport: (data) => {
		let url = "delete_aggregated_report";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
	getreportdetails: (data) => {
		let url = "get_aggregated_report_details";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
	savereportview: (data) => {
		let url = "save_aggregated_report_view";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
	createreport: (data) => {
		let url = "create_aggregated_report";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
	getprimarygoals: (data) => {
		let url = "get_aggregated_primary_goals";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
	getgoalbreakdown: (data) => {
		let url = "get_aggregated_goal_breakdown";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
	getprimarygoalmetrics: (data) => {
		let url = "get_aggregated_primary_goal_metrics";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
	getlifecycle: (data) => {
		let url = "get_aggregated_lifecycle";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
	getfunnelrows: (data) => {
		let url = "get_aggregated_funnel_rows";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
	getfunneltraffic: (data) => {
		let url = "get_aggregated_funnel_traffic";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
	getadnetworkdata: (data) => {
		let url = "get_aggregated_ad_network_data";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
	/* Assisted + Influenced Revenue for ONE ad and ONE goal, fetched only when the user asks.
	   One call returns both metrics, so opening either column costs a single request. */
	getadassistmetrics: (data) => {
		let url = "get_aggregated_ad_assist_metrics";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
	/* Assisted Conversion + Influenced Revenue for EVERY ad on the page, in one request.
	   The column is switched on in the chooser, not per row, so the table needs all of its
	   cells at once; one batched call keeps that from becoming a request per row. */
	getadassistmetricsbulk: (data) => {
		let url = "get_aggregated_ad_assist_metrics_bulk";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
	gettrackingtagdropdown: (data) => {
		let url = "get_aggregated_tracking_tag_dropdown";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
	getcustomtagdropdown: (data) => {
		let url = "get_aggregated_custom_tag_dropdown";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
	getsourcedropdown: (data) => {
		let url = "get_aggregated_source_dropdown";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
	getadvancedfiltertables: (data) => {
		let url = "get_aggregated_advanced_filter_tables";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
	saveadvancedfilters: (data) => {
		let url = "save_aggregated_advanced_filters";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
	getinsightschart: (data) => {
		let url = "get_aggregated_insights_chart";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
	getvelocitydrawerdata: (data) => {
		let url = "get_aggregated_velocity_drawer_data";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
	getlifecyclevelocitydrawerdata: (data) => {
		let url = "get_aggregated_lifecycle_velocity_drawer_data";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
	getcustomerjourneylist: (data) => {
		let url = "get_aggregated_customer_journey_list";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
	getresetcampaigns: (data) => {
		let url = "get_aggregated_reset_campaigns";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
	resetstats: (data) => {
		let url = "reset_aggregated_report_stats";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
	getconversionlogdetails: (data) => {
		let url = "get_aggregated_conversion_log_details";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
	getconversionlog: (data) => {
		let url = "get_aggregated_conversion_log";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
	getvariationads: (data) => {
		let url = "get_aggregated_variation_ads";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
	getkeywordexport: (data) => {
		let url = "get_aggregated_keyword_export";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
	getadkeyworddrawerdata: (data) => {
		let url = "get_aggregated_ad_keyword_drawer_data";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
	getcampaignnote: (data) => {
		let url = "get_aggregated_campaign_note";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
	savecampaignnote: (data) => {
		let url = "save_aggregated_campaign_note";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
	getkeyworddrawerdata: (data) => {
		let url = "get_aggregated_keyword_drawer_data";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
};

export default AggregatedReportsAPI;
